import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import {
    Box, Button,
    Flex,
    HStack,
    Heading, Image,
    Link,
    Stack,
    Text
} from "@chakra-ui/react";
import React, { useState } from 'react';
const PropertyDetailIntro = (props) => {
    console.log("props in property img", props.data);
    const [currentIndex, setCurrentIndex] = useState(0);
    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % props.data?.length);
    };
    const prevImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + props.data?.length) % props.data?.length);
    };
    return (
        <>
            {props.data ? <>
                <Stack justify='center' w="100%" h={{ base: "250px", sm: "300px", md: "500px" }} position="relative">
                    {console.log("Property img", props.data)}
                    <Image w="100%" maxH="100%" src={props.data[currentIndex]} alt="property" />
                    <Button _hover={{ bgColor: "black" }} w={{ base: "24px", md: "47px" }} h={{ base: "34px", md: "68px" }} onClick={prevImage} position="absolute" top="50%" variant="ghost"><ChevronLeftIcon color="white" fontSize={{ base: "24px", md: "48px" }} /> </Button>
                    <Button _hover={{ bgColor: "black" }} w={{ base: "24px", md: "47px" }} h={{ base: "34px", md: "68px" }} onClick={nextImage} right="0" position="absolute" top="50%" variant="ghost"><ChevronRightIcon color="white" fontSize={{ base: "24px", md: "48px" }} /> </Button>
                </Stack><HStack my="16px" rowGap="8px" justify='center' wrap="wrap">
                    {props.data?.map((property, index) => {
                        return (
                            <Image key={index} borderRadius="7px" w="80px" h="80px" src={property} alt="property"></Image>
                        );
                    })}
                </HStack><Flex mt="40px" align="center" w="100%" fontSize="17px" borderBottom="1px #D9D9D9 solid" flexDirection={{ base: "column", md: "row" }}>
                    <Box borderRight={{ md: "1px #D9D9D9 solid" }} w={{ md: "25%" }} textAlign="center" p="0 12px 30px">
                        <Heading fontSize="20px" fontWeight="500" mb="8px">Property Type</Heading>
                        <Text>{props.propertyType}</Text>
                    </Box>
                    <Box borderRight={{ md: "1px #D9D9D9 solid" }} w={{ md: "33.3%" }} textAlign="center" p="0 12px 30px">
                        <Heading fontSize="20px" fontWeight="500" mb="8px">Property Class</Heading>
                        <Text>{props.propertyClass}</Text>
                    </Box>
                    <Box borderRight={{ md: "1px #D9D9D9 solid" }} w={{ md: "41.6%" }} textAlign="center" p="0 12px 30px">
                        <Heading fontSize="20px" fontWeight="500" mb="8px">Get Private Documents</Heading>
                        {props.documents?.length != 0 &&
                            <>
                                <Link href={props.documents[0].file} target="_blank" textDecoration="underline">Accept Confidentiality</Link><br />
                                <Link href={props.documents[0].file} target="_blank" textDecoration="underline">Agreement</Link>
                            </>
                        }
                    </Box>
                </Flex></>
                : null
            }
        </>
    );
}

export default PropertyDetailIntro;